import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { api } from "@/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Vendedor } from "@/shared/types/vendedor";

export interface VendedorAddRequest {
    nombre: string,
    numDocumento: string,
    porcentajeComision:number,
    email?: string,
    telefono?: string,
    direccion?: string,
}

export async function addVendedor(request: VendedorAddRequest): Promise<Vendedor> {
    await sleep(1000);
    const response = await api.post("vendedores", request);
    return response.data;
}

export function useAddVendedorMutation(mutationConfig: MutationConfig<Vendedor, VendedorAddRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: addVendedor,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["vendedores"] });
        },
    })
}

export interface AddVendedorMutationProps {
    mutationConfig?: MutationConfig<Vendedor, VendedorAddRequest>
    children?: (mutationResult: MutationResult<Vendedor, VendedorAddRequest>) => ReactNode
}

export function AddVendedorMutation({
    mutationConfig,
    children
}: AddVendedorMutationProps) {
    const mutationResult = useAddVendedorMutation(mutationConfig);
    return children && children(mutationResult);
}